module.exports = __webpack_public_path__ + "img/flag_massachu.57478c59.png";